/**
 * Authentication-related constants
 * Centralized to avoid magic numbers and improve maintainability
 */

export const AUTH_CONSTANTS = {
  // Verification Code
  VERIFICATION_CODE_LENGTH: 6,
  MAX_VERIFICATION_ATTEMPTS: 3,
  VERIFICATION_EXPIRY_MINUTES: 10,
  
  // OAuth
  OAUTH_STATE_SEPARATOR: '|',
  
  // Session Storage Keys
  SESSION_KEYS: {
    VERIFICATION_DATA: 'verificationData',
    OAUTH_CSRF: 'oauth_csrf',
    OAUTH_STATE: 'oauth_state',
    REDIRECT_AFTER_LOGIN: 'redirectAfterLogin',
  },
  
  // User Roles
  ROLES: {
    ADMIN: 'Admin',
    WORSHIP_LEADER: 'WorshipLeader',
    MEMBER: 'Member',
  },
  
  // Token Types
  TOKEN_TYPES: {
    ADMIN: 'admin',
    USER: 'user',
  },
} as const;

// Type-safe session storage keys
export type SessionStorageKey = typeof AUTH_CONSTANTS.SESSION_KEYS[keyof typeof AUTH_CONSTANTS.SESSION_KEYS];
